import React, { useState } from 'react';
import { Card, Select, Modal, message } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import FormikForm from '../form/FormikForm';

const { Option } = Select;

const KayitEklePage = () => {
    const { darkMode } = useTheme();
    const [formModalOpen, setFormModalOpen] = useState(false);
    const [currentFormId, setCurrentFormId] = useState(null);
    const [modalTitle, setModalTitle] = useState('');
    const [selectedType, setSelectedType] = useState(null);

    const kayitTuruOptions = [
        { 
            value: 'personel', 
            label: 'Personel Ekle', 
            formId: 172,
            title: 'Personel Ekle'
        },
        { 
            value: 'giris-cikis', 
            label: 'Giriş-Çıkış Ekle', 
            formId: 247, 
            title: 'Giriş-Çıkış Ekle'
        },
        { 
            value: 'izin', 
            label: 'İzin Ekle', 
            formId: 267, 
            title: 'İzin Talebi Ekle'
        },
        { 
            value: 'fatura', 
            label: 'Fatura Talebi Ekle', 
            formId: 189, 
            title: 'Fatura Talebi Ekle'
        }
    ];

    const handleOpenForm = (formId, title = 'Form', extraData = null) => {
        setModalTitle(title);
        setCurrentFormId(formId);
        setCurrentFormExtraData(extraData || {});
        setFormModalOpen(true);
    };

    const handleTypeSelect = (value) => {
        setSelectedType(value);
        const selectedOption = kayitTuruOptions.find(opt => opt.value === value);

        if (selectedOption && selectedOption.formId) {
            const extraData = {
                kul_no: user?.kullanici_no ?? null,
            };
            handleOpenForm(selectedOption.formId, selectedOption.title, extraData);
        } else {
            message.warning('Bu kayıt türü için henüz form tanımlı değil');
        }
    };

    const handleFormSuccess = () => {
        setFormModalOpen(false);
        setCurrentFormId(null);
        setSelectedType(null);
        setCurrentFormExtraData({});
        message.success('Kayıt başarıyla eklendi');
    };

    const closeFormModal = () => {
        setFormModalOpen(false);
        setCurrentFormId(null);
        setCurrentFormExtraData({});
    };

    return (
        <div style={{ padding: 12 }}>
            <Card
                title="Yeni Kayıt Ekle"
                style={{
                    background: darkMode ? '#1b1d22' : '#fff',
                    border: `1px solid ${darkMode ? '#434343' : '#d9d9d9'}`
                }}
                bodyStyle={{
                    minHeight: '400px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <div style={{ width: '100%', maxWidth: 200 }}>
                    <div style={{ marginBottom: 8 }}>
                        <label style={{ 
                            display: 'block', 
                            marginBottom: 4,
                            color: darkMode ? '#fff' : '#000',
                            fontWeight: 400
                        }}>
                            Kayıt Türü Seçin
                        </label>
                        <Select
                            placeholder="Kayıt türü seçin..."
                            style={{ width: '80%' }}
                            size="large"
                            value={selectedType}
                            onChange={handleTypeSelect}
                        >
                            {kayitTuruOptions.map(option => (
                                <Option key={option.value} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                        </Select>
                    </div>
                </div>
            </Card>

            {/* Form Modal */}
            {formModalOpen && currentFormId && (
                <Modal
                    title={modalTitle}
                    open={formModalOpen}
                    onCancel={closeFormModal}
                    footer={null}
                    destroyOnClose
                    width={800}
                    styles={{ body: { maxHeight: '80vh', overflowY: 'auto', padding: '24px' } }}
                >
                    <FormikForm
                        formId={currentFormId}
                        onSuccess={handleFormSuccess}
                        extraData={currentFormExtraData}
                    />
                </Modal>
            )}
        </div>
    );
};

export default KayitEklePage;